import React from 'react';

import TalentAssessmentPage from 'components/Members/TalentAssessment/Views/New/Index';

import { useContext } from 'components/Members/Onboarding/Context';

import StepTab from 'components/new_ui/Tabs/StepTab';

export default function TalentAssessment() {
  const { dispatch, state, actions } = useContext();

  const onGoNextClick = () => {
    actions.completeStep(state.steps[state.currentStep].step, () => {
      actions.setNextStep({
        dispatch,
        steps: state.steps,
        isPossibleSkip: false,
        currentStep: state.currentStep,
      });
    });
  };

  return (
    <div className="onboarding-content">
      {state.workflow === 'PROGRAM_ONBOARDING' && <StepTab total={5} current={1} />}

      <TalentAssessmentPage
        onNextStep={onGoNextClick}
        title="Talent Assessment"
      />
    </div>
  );
}
